import { post, get } from './request'

export let signup = (payload, success, failure) => post('/api/signup', payload, success, failure)

export let authenticate = (user, success, failure) => post('/signin', user, success, failure)

export let loadUser = (success, failure) => get('/api/user', success, failure)

export let loadApiKeys = (success, failure) => get('/api/api-keys', success, failure)